/**
 * Hindi Names for Soap Making Ingredients & Recipes
 * Authentic Indian naming for brand identity
 * 
 * Format: { english: hindi, hindiRomanized }
 */

// ===== OILS (तेल - Tel) =====
export const OIL_NAMES_HINDI = {
  // Common Oils
  olive_oil: { hindi: "जैतून का तेल", romanized: "Jaitun Ka Tel" },
  olive: { hindi: "जैतून का तेल", romanized: "Jaitun Ka Tel" },
  
  coconut_oil: { hindi: "नारियल का तेल", romanized: "Nariyal Ka Tel" },
  coconut: { hindi: "नारियल का तेल", romanized: "Nariyal Ka Tel" },
  
  palm_oil: { hindi: "ताड़ का तेल", romanized: "Taad Ka Tel" },
  palm: { hindi: "ताड़ का तेल", romanized: "Taad Ka Tel" },
  
  castor_oil: { hindi: "अरंडी का तेल", romanized: "Arandi Ka Tel" },
  castor: { hindi: "अरंडी का तेल", romanized: "Arandi Ka Tel" },
  
  // Indian Staple Oils
  mustard_oil: { hindi: "सरसों का तेल", romanized: "Sarson Ka Tel" },
  mustard: { hindi: "सरसों का तेल", romanized: "Sarson Ka Tel" },
  
  sesame_oil: { hindi: "तिल का तेल", romanized: "Til Ka Tel" },
  sesame: { hindi: "तिल का तेल", romanized: "Til Ka Tel" },
  
  groundnut_oil: { hindi: "मूंगफली का तेल", romanized: "Moongfali Ka Tel" },
  peanut_oil: { hindi: "मूंगफली का तेल", romanized: "Moongfali Ka Tel" },
  peanut: { hindi: "मूंगफली का तेल", romanized: "Moongfali Ka Tel" },
  
  sunflower_oil: { hindi: "सूरजमुखी का तेल", romanized: "Surajmukhi Ka Tel" },
  sunflower: { hindi: "सूरजमुखी का तेल", romanized: "Surajmukhi Ka Tel" },
  
  rice_bran_oil: { hindi: "चावल की भूसी का तेल", romanized: "Chawal Ki Bhusi Ka Tel" },
  ricebran: { hindi: "चावल की भूसी का तेल", romanized: "Chawal Ki Bhusi Ka Tel" },
  
  neem_oil: { hindi: "नीम का तेल", romanized: "Neem Ka Tel" },
  neem: { hindi: "नीम का तेल", romanized: "Neem Ka Tel" },
  
  almond_oil: { hindi: "बादाम का तेल", romanized: "Badam Ka Tel" },
  sweet_almond_oil: { hindi: "बादाम का तेल", romanized: "Badam Ka Tel" },
  almond: { hindi: "बादाम का तेल", romanized: "Badam Ka Tel" },
  
  // Premium/Specialty Oils
  avocado_oil: { hindi: "एवोकाडो का तेल", romanized: "Avocado Ka Tel" },
  avocado: { hindi: "एवोकाडो का तेल", romanized: "Avocado Ka Tel" },
  
  jojoba_oil: { hindi: "जोजोबा का तेल", romanized: "Jojoba Ka Tel" },
  jojoba: { hindi: "जोजोबा का तेल", romanized: "Jojoba Ka Tel" },
  
  grapeseed_oil: { hindi: "अंगूर के बीज का तेल", romanized: "Angoor Ke Beej Ka Tel" },
  grapeseed: { hindi: "अंगूर के बीज का तेल", romanized: "Angoor Ke Beej Ka Tel" },
  
  hempseed_oil: { hindi: "भांग के बीज का तेल", romanized: "Bhang Ke Beej Ka Tel" },
  hemp: { hindi: "भांग के बीज का तेल", romanized: "Bhang Ke Beej Ka Tel" },
  
  walnut_oil: { hindi: "अखरोट का तेल", romanized: "Akhrot Ka Tel" },
  walnut: { hindi: "अखरोट का तेल", romanized: "Akhrot Ka Tel" },
  
  flaxseed_oil: { hindi: "अलसी का तेल", romanized: "Alsi Ka Tel" },
  linseed_oil: { hindi: "अलसी का तेल", romanized: "Alsi Ka Tel" },
  flaxseed: { hindi: "अलसी का तेल", romanized: "Alsi Ka Tel" },
  
  safflower_oil: { hindi: "कुसुम का तेल", romanized: "Kusum Ka Tel" },
  safflower: { hindi: "कुसुम का तेल", romanized: "Kusum Ka Tel" },
  
  canola_oil: { hindi: "कनोला का तेल", romanized: "Canola Ka Tel" },
  canola: { hindi: "कनोला का तेल", romanized: "Canola Ka Tel" },
  
  apricot_kernel_oil: { hindi: "खुबानी के बीज का तेल", romanized: "Khubani Ke Beej Ka Tel" },
  apricot: { hindi: "खुबानी के बीज का तेल", romanized: "Khubani Ke Beej Ka Tel" },
};

// ===== BUTTERS (मक्खन - Makkhan) =====
export const BUTTER_NAMES_HINDI = {
  shea_butter: { hindi: "शिया मक्खन", romanized: "Shea Makkhan" },
  shea: { hindi: "शिया मक्खन", romanized: "Shea Makkhan" },
  
  cocoa_butter: { hindi: "कोको मक्खन", romanized: "Coco Makkhan" },
  cocoa: { hindi: "कोको मक्खन", romanized: "Coco Makkhan" },
  
  mango_butter: { hindi: "आम का मक्खन", romanized: "Aam Ka Makkhan" },
  mango: { hindi: "आम का मक्खन", romanized: "Aam Ka Makkhan" },
  
  kokum_butter: { hindi: "कोकम मक्खन", romanized: "Kokum Makkhan" },
  kokum: { hindi: "कोकम मक्खन", romanized: "Kokum Makkhan" },
  
  sal_butter: { hindi: "साल मक्खन", romanized: "Saal Makkhan" },
  sal: { hindi: "साल मक्खन", romanized: "Saal Makkhan" },
};

// ===== ESSENTIAL OILS (सुगंधित तेल - Sugandhit Tel) =====
export const ESSENTIAL_OIL_NAMES_HINDI = {
  lavender: { hindi: "लैवेंडर", romanized: "Lavender" },
  lavender_essential_oil: { hindi: "लैवेंडर का तेल", romanized: "Lavender Ka Tel" },
  
  peppermint: { hindi: "पुदीना", romanized: "Pudina" },
  peppermint_essential_oil: { hindi: "पुदीना का तेल", romanized: "Pudina Ka Tel" },
  
  eucalyptus: { hindi: "नीलगिरी", romanized: "Nilgiri" },
  eucalyptus_essential_oil: { hindi: "नीलगिरी का तेल", romanized: "Nilgiri Ka Tel" },
  
  tea_tree: { hindi: "टी ट्री", romanized: "Tea Tree" },
  tea_tree_essential_oil: { hindi: "टी ट्री का तेल", romanized: "Tea Tree Ka Tel" },
  
  lemongrass: { hindi: "लेमनग्रास", romanized: "Lemongrass" },
  lemongrass_essential_oil: { hindi: "लेमनग्रास का तेल", romanized: "Lemongrass Ka Tel" },
  
  rosemary: { hindi: "रोज़मेरी", romanized: "Rosemary" },
  rosemary_essential_oil: { hindi: "रोज़मेरी का तेल", romanized: "Rosemary Ka Tel" },
  
  // Indian Essential Oils
  sandalwood: { hindi: "चंदन", romanized: "Chandan" },
  sandalwood_essential_oil: { hindi: "चंदन का तेल", romanized: "Chandan Ka Tel" },
  
  jasmine: { hindi: "चमेली", romanized: "Chameli" },
  jasmine_essential_oil: { hindi: "चमेली का तेल", romanized: "Chameli Ka Tel" },
  
  rose: { hindi: "गुलाब", romanized: "Gulab" },
  rose_essential_oil: { hindi: "गुलाब का तेल", romanized: "Gulab Ka Tel" },
  
  turmeric: { hindi: "हल्दी", romanized: "Haldi" },
  turmeric_essential_oil: { hindi: "हल्दी का तेल", romanized: "Haldi Ka Tel" },
  
  vetiver: { hindi: "खस", romanized: "Khas" },
  vetiver_essential_oil: { hindi: "खस का तेल", romanized: "Khas Ka Tel" },
  
  camphor: { hindi: "कपूर", romanized: "Kapoor" },
  camphor_oil: { hindi: "कपूर का तेल", romanized: "Kapoor Ka Tel" },
  
  frankincense: { hindi: "लोबान", romanized: "Loban" },
  frankincense_essential_oil: { hindi: "लोबान का तेल", romanized: "Loban Ka Tel" },
  
  patchouli: { hindi: "पचौली", romanized: "Pachouli" },
  patchouli_essential_oil: { hindi: "पचौली का तेल", romanized: "Pachouli Ka Tel" },
};

// ===== ADDITIVES & CLAYS (योजक - Yojak) =====
export const ADDITIVE_NAMES_HINDI = {
  // Clays
  kaolin_clay: { hindi: "मुल्तानी मिट्टी (सफेद)", romanized: "Multani Mitti (Safed)" },
  kaolin: { hindi: "मुल्तानी मिट्टी (सफेद)", romanized: "Multani Mitti (Safed)" },
  
  bentonite_clay: { hindi: "बेंटोनाइट मिट्टी", romanized: "Bentonite Mitti" },
  bentonite: { hindi: "बेंटोनाइट मिट्टी", romanized: "Bentonite Mitti" },
  
  french_green_clay: { hindi: "हरी मिट्टी", romanized: "Hari Mitti" },
  green_clay: { hindi: "हरी मिट्टी", romanized: "Hari Mitti" },
  
  fuller_earth: { hindi: "मुल्तानी मिट्टी", romanized: "Multani Mitti" },
  multani_mitti: { hindi: "मुल्तानी मिट्टी", romanized: "Multani Mitti" },
  
  // Natural Powders
  activated_charcoal: { hindi: "सक्रिय चारकोल", romanized: "Sakriya Charcoal" },
  charcoal: { hindi: "चारकोल", romanized: "Charcoal" },
  
  turmeric_powder: { hindi: "हल्दी पाउडर", romanized: "Haldi Powder" },
  turmeric: { hindi: "हल्दी", romanized: "Haldi" },
  
  neem_powder: { hindi: "नीम पाउडर", romanized: "Neem Powder" },
  
  sandalwood_powder: { hindi: "चंदन पाउडर", romanized: "Chandan Powder" },
  
  ubtan: { hindi: "उबटन", romanized: "Ubtan" },
  
  besan: { hindi: "बेसन", romanized: "Besan" },
  gram_flour: { hindi: "बेसन", romanized: "Besan" },
  chickpea_flour: { hindi: "बेसन", romanized: "Besan" },
  
  rice_flour: { hindi: "चावल का आटा", romanized: "Chawal Ka Aata" },
  
  oatmeal: { hindi: "जई का आटा", romanized: "Jai Ka Aata" },
  oats: { hindi: "जई", romanized: "Jai" },
  
  honey: { hindi: "शहद", romanized: "Shahad" },
  
  milk: { hindi: "दूध", romanized: "Doodh" },
  goat_milk: { hindi: "बकरी का दूध", romanized: "Bakri Ka Doodh" },
  coconut_milk: { hindi: "नारियल का दूध", romanized: "Nariyal Ka Doodh" },
  
  aloe_vera: { hindi: "एलोवेरा / घृतकुमारी", romanized: "Aloe Vera / Ghritkumari" },
  
  rose_water: { hindi: "गुलाब जल", romanized: "Gulab Jal" },
  
  coffee: { hindi: "कॉफ़ी", romanized: "Coffee" },
  coffee_grounds: { hindi: "कॉफ़ी पाउडर", romanized: "Coffee Powder" },
  
  sea_salt: { hindi: "समुद्री नमक", romanized: "Samudri Namak" },
  himalayan_salt: { hindi: "हिमालयन नमक", romanized: "Himalayan Namak" },
  
  vitamin_e: { hindi: "विटामिन ई", romanized: "Vitamin E" },
  
  glycerin: { hindi: "ग्लिसरीन", romanized: "Glycerin" },
};

// ===== AYURVEDIC INGREDIENTS (आयुर्वेदिक सामग्री) =====
export const AYURVEDIC_NAMES_HINDI = {
  ashwagandha: { hindi: "अश्वगंधा", romanized: "Ashwagandha" },
  brahmi: { hindi: "ब्राह्मी", romanized: "Brahmi" },
  tulsi: { hindi: "तुलसी", romanized: "Tulsi" },
  holy_basil: { hindi: "तुलसी", romanized: "Tulsi" },
  amla: { hindi: "आंवला", romanized: "Amla" },
  indian_gooseberry: { hindi: "आंवला", romanized: "Amla" },
  shikakai: { hindi: "शिकाकाई", romanized: "Shikakai" },
  reetha: { hindi: "रीठा", romanized: "Reetha" },
  soapnut: { hindi: "रीठा", romanized: "Reetha" },
  bhringraj: { hindi: "भृंगराज", romanized: "Bhringraj" },
  manjistha: { hindi: "मंजिष्ठा", romanized: "Manjistha" },
  lodhra: { hindi: "लोध्र", romanized: "Lodhra" },
  yashtimadhu: { hindi: "यष्टिमधु / मुलेठी", romanized: "Yashtimadhu / Mulethi" },
  licorice: { hindi: "मुलेठी", romanized: "Mulethi" },
  kumkumadi: { hindi: "कुमकुमादि", romanized: "Kumkumadi" },
  kesar: { hindi: "केसर", romanized: "Kesar" },
  saffron: { hindi: "केसर", romanized: "Kesar" },
  giloy: { hindi: "गिलोय", romanized: "Giloy" },
  triphala: { hindi: "त्रिफला", romanized: "Triphala" },
  haritaki: { hindi: "हरीतकी", romanized: "Haritaki" },
  bibhitaki: { hindi: "बिभीतकी", romanized: "Bibhitaki" },
};

// ===== SOAP-MAKING TERMS (साबुन शब्दावली) =====
export const SOAP_TERMS_HINDI = {
  soap: { hindi: "साबुन", romanized: "Sabun" },
  handmade_soap: { hindi: "हाथ का बना साबुन", romanized: "Haath Ka Bana Sabun" },
  natural_soap: { hindi: "प्राकृतिक साबुन", romanized: "Prakritik Sabun" },
  herbal_soap: { hindi: "जड़ी-बूटी साबुन", romanized: "Jadi-Booti Sabun" },
  ayurvedic_soap: { hindi: "आयुर्वेदिक साबुन", romanized: "Ayurvedic Sabun" },
  
  lye: { hindi: "क्षार / लाई", romanized: "Kshaar / Lye" },
  sodium_hydroxide: { hindi: "सोडियम हाइड्रॉक्साइड", romanized: "Sodium Hydroxide" },
  
  saponification: { hindi: "साबुनीकरण", romanized: "Sabunikaran" },
  cold_process: { hindi: "शीत प्रक्रिया", romanized: "Sheet Prakriya" },
  hot_process: { hindi: "गर्म प्रक्रिया", romanized: "Garam Prakriya" },
  
  cure: { hindi: "परिपक्व करना", romanized: "Paripakva Karna" },
  curing: { hindi: "परिपक्वन", romanized: "Paripakvan" },
  
  trace: { hindi: "ट्रेस", romanized: "Trace" },
  superfat: { hindi: "अतिरिक्त वसा", romanized: "Atirikt Vasa" },
  
  batch: { hindi: "बैच", romanized: "Batch" },
  recipe: { hindi: "विधि / नुस्खा", romanized: "Vidhi / Nuskha" },
  ingredients: { hindi: "सामग्री", romanized: "Samagri" },
  
  moisturizing: { hindi: "मॉइस्चराइज़िंग", romanized: "Moisturizing" },
  cleansing: { hindi: "सफाई करने वाला", romanized: "Safai Karne Wala" },
  lather: { hindi: "झाग", romanized: "Jhaag" },
  hardness: { hindi: "कठोरता", romanized: "Kathorata" },
};

// ===== RECIPE NAME SUGGESTIONS (नुस्खा नाम) =====
export const RECIPE_NAME_SUGGESTIONS = {
  // By Primary Ingredient
  sandalwood_soap: { hindi: "चंदन साबुन", romanized: "Chandan Sabun" },
  turmeric_soap: { hindi: "हल्दी साबुन", romanized: "Haldi Sabun" },
  neem_soap: { hindi: "नीम साबुन", romanized: "Neem Sabun" },
  rose_soap: { hindi: "गुलाब साबुन", romanized: "Gulab Sabun" },
  jasmine_soap: { hindi: "चमेली साबुन", romanized: "Chameli Sabun" },
  multani_mitti_soap: { hindi: "मुल्तानी मिट्टी साबुन", romanized: "Multani Mitti Sabun" },
  honey_soap: { hindi: "शहद साबुन", romanized: "Shahad Sabun" },
  milk_soap: { hindi: "दूध साबुन", romanized: "Doodh Sabun" },
  aloe_vera_soap: { hindi: "एलोवेरा साबुन", romanized: "Aloe Vera Sabun" },
  charcoal_soap: { hindi: "चारकोल साबुन", romanized: "Charcoal Sabun" },
  coffee_soap: { hindi: "कॉफ़ी साबुन", romanized: "Coffee Sabun" },
  saffron_soap: { hindi: "केसर साबुन", romanized: "Kesar Sabun" },
  tulsi_soap: { hindi: "तुलसी साबुन", romanized: "Tulsi Sabun" },
  
  // Traditional/Ayurvedic Names
  ubtan_soap: { hindi: "उबटन साबुन", romanized: "Ubtan Sabun" },
  kumkumadi_soap: { hindi: "कुमकुमादि साबुन", romanized: "Kumkumadi Sabun" },
  panchagavya_soap: { hindi: "पंचगव्य साबुन", romanized: "Panchagavya Sabun" },
  
  // By Benefit
  glow_soap: { hindi: "निखार साबुन", romanized: "Nikhaar Sabun" },
  moisturizing_soap: { hindi: "नमी साबुन", romanized: "Nami Sabun" },
  
  // Poetic/Brand Names
  sundari: { hindi: "सुंदरी", romanized: "Sundari", meaning: "Beautiful one" },
  nirmal: { hindi: "निर्मल", romanized: "Nirmal", meaning: "Pure/Clean" },
  sneha: { hindi: "स्नेहा", romanized: "Sneha", meaning: "Love/Affection" },
  kanti: { hindi: "कांति", romanized: "Kanti", meaning: "Radiance/Glow" },
  swarna: { hindi: "स्वर्ण", romanized: "Swarna", meaning: "Golden" },
  pushp: { hindi: "पुष्प", romanized: "Pushp", meaning: "Flower" },
  madhur: { hindi: "मधुर", romanized: "Madhur", meaning: "Sweet" },
  shubhra: { hindi: "शुभ्र", romanized: "Shubhra", meaning: "Bright/White" },
  lavanya: { hindi: "लावण्य", romanized: "Lavanya", meaning: "Grace/Beauty" },
  sugandh: { hindi: "सुगंध", romanized: "Sugandh", meaning: "Fragrance" },
  sparsh: { hindi: "स्पर्श", romanized: "Sparsh", meaning: "Touch" },
  mridul: { hindi: "मृदुल", romanized: "Mridul", meaning: "Soft/Gentle" },
  pavitra: { hindi: "पवित्र", romanized: "Pavitra", meaning: "Holy/Pure" },
  shuddh: { hindi: "शुद्ध", romanized: "Shuddh", meaning: "Pure" },
};

// ===== DOSHA-BASED NAMES (दोष आधारित) =====
export const DOSHA_NAMES = {
  vata: { hindi: "वात", romanized: "Vaat", description: "Air + Space - Dry, cold skin" },
  pitta: { hindi: "पित्त", romanized: "Pitta", description: "Fire + Water - Sensitive, oily skin" },
  kapha: { hindi: "कफ", romanized: "Kapha", description: "Earth + Water - Oily, thick skin" },
  tridosha: { hindi: "त्रिदोष", romanized: "Tridosha", description: "Balances all three doshas" },
};

// ===== UTILITY FUNCTIONS =====

/**
 * Get all Hindi translations for an ingredient
 * @param {string} key - Ingredient key (e.g., "coconut_oil", "turmeric")
 * @returns {{ hindi: string, romanized: string } | null}
 */
export const getHindiName = (key) => {
  if (!key) return null;
  const normalizedKey = key.toLowerCase().replace(/[\s-]/g, "_");
  
  return (
    OIL_NAMES_HINDI[normalizedKey] ||
    BUTTER_NAMES_HINDI[normalizedKey] ||
    ESSENTIAL_OIL_NAMES_HINDI[normalizedKey] ||
    ADDITIVE_NAMES_HINDI[normalizedKey] ||
    AYURVEDIC_NAMES_HINDI[normalizedKey] ||
    SOAP_TERMS_HINDI[normalizedKey] ||
    null
  );
};

/**
 * Get Hindi recipe name suggestion based on main ingredients
 * @param {string[]} mainIngredients - Array of main ingredient keys
 * @returns {string} - Suggested Hindi recipe name
 */
export const suggestHindiRecipeName = (mainIngredients = []) => {
  if (!mainIngredients.length) return RECIPE_NAME_SUGGESTIONS.sundari;
  
  const primary = mainIngredients[0]?.toLowerCase().replace(/[\s-]/g, "_");
  
  // Check direct recipe matches
  if (RECIPE_NAME_SUGGESTIONS[`${primary}_soap`]) {
    return RECIPE_NAME_SUGGESTIONS[`${primary}_soap`];
  }
  
  // Check ingredient name and create compound
  const hindiIngredient = getHindiName(primary);
  if (hindiIngredient) {
    return {
      hindi: `${hindiIngredient.hindi} साबुन`,
      romanized: `${hindiIngredient.romanized} Sabun`,
    };
  }
  
  // Fallback to a poetic name
  const poeticNames = ['sundari', 'nirmal', 'sneha', 'kanti', 'lavanya'];
  const randomPoetic = poeticNames[Math.floor(Math.random() * poeticNames.length)];
  return RECIPE_NAME_SUGGESTIONS[randomPoetic];
};

/**
 * Format ingredient with Hindi name for display
 * @param {string} name - English name
 * @param {string} key - Ingredient key
 * @param {boolean} showHindiScript - Whether to show Devanagari script
 * @returns {string} - Formatted name
 */
export const formatIngredientWithHindi = (name, key, showHindiScript = true) => {
  const hindi = getHindiName(key);
  if (!hindi) return name;
  
  if (showHindiScript) {
    return `${name} (${hindi.hindi} - ${hindi.romanized})`;
  }
  return `${name} (${hindi.romanized})`;
};

/**
 * Get all ingredients with Hindi names as array for dropdown/display
 * @returns {Array} - Array of { key, english, hindi, romanized }
 */
export const getAllIngredientsWithHindi = () => {
  const allMaps = [
    { map: OIL_NAMES_HINDI, category: 'oil' },
    { map: BUTTER_NAMES_HINDI, category: 'butter' },
    { map: ESSENTIAL_OIL_NAMES_HINDI, category: 'essential_oil' },
    { map: ADDITIVE_NAMES_HINDI, category: 'additive' },
    { map: AYURVEDIC_NAMES_HINDI, category: 'ayurvedic' },
  ];
  
  const seen = new Set();
  const results = [];
  
  allMaps.forEach(({ map, category }) => {
    Object.entries(map).forEach(([key, value]) => {
      // Skip duplicates (same hindi name)
      const uniqueKey = `${value.hindi}`;
      if (seen.has(uniqueKey)) return;
      seen.add(uniqueKey);
      
      results.push({
        key,
        english: key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
        hindi: value.hindi,
        romanized: value.romanized,
        category,
      });
    });
  });
  
  return results;
};

// Combined lookup for all categories
export const ALL_HINDI_NAMES = {
  ...OIL_NAMES_HINDI,
  ...BUTTER_NAMES_HINDI,
  ...ESSENTIAL_OIL_NAMES_HINDI,
  ...ADDITIVE_NAMES_HINDI,
  ...AYURVEDIC_NAMES_HINDI,
  ...SOAP_TERMS_HINDI,
};

export default {
  OIL_NAMES_HINDI,
  BUTTER_NAMES_HINDI,
  ESSENTIAL_OIL_NAMES_HINDI,
  ADDITIVE_NAMES_HINDI,
  AYURVEDIC_NAMES_HINDI,
  SOAP_TERMS_HINDI,
  RECIPE_NAME_SUGGESTIONS,
  DOSHA_NAMES,
  getHindiName,
  suggestHindiRecipeName,
  formatIngredientWithHindi,
  getAllIngredientsWithHindi,
  ALL_HINDI_NAMES,
};
